import { render, staticRenderFns } from "./BotaoCarregar.vue?vue&type=template&id=106ada54&scoped=true&"
import script from "./BotaoCarregar.vue?vue&type=script&lang=js&"
export * from "./BotaoCarregar.vue?vue&type=script&lang=js&"
import style0 from "./BotaoCarregar.vue?vue&type=style&index=0&id=106ada54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ada54",
  null
  
)

export default component.exports